import axios from 'axios'
import errorHandler from './error-handler'

export default {
  async attachGreenHouse (data, companyId) {
    return axios.put(`/api/companies/${companyId}/config/green-house/`, {...data}).then(r => r.data).catch(errorHandler)
  },
  async checkGreenHouse (companyId) {
    return axios.get(`/api/companies/${companyId}/config/green-house/`).then(r => r.data).catch(errorHandler)
  },
  async disconnectGreenHouse (companyId) {
    return axios.delete(`/api/companies/${companyId}/config/green-house/`).then(r => r.data).catch(errorHandler)
  },
  async generatePassword (companyId) {
    return axios.post(`/api/companies/${companyId}/config/green-house/regenerate-password`).then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/green-house.js